import ControlCenterNewsListItemNode from "./ControlCenterNewsListItem";
import ControlCenterNewsListItemSkeleton from "./ControlCenterNewsListItem.skeleton";

export const ControlCenterNewsListItem = {
  Node: ControlCenterNewsListItemNode,
  Skeleton: ControlCenterNewsListItemSkeleton,
};
